import {
  ADMIN_CID_PAYOUT_STATUS_LOADED,
  ADMIN_CID_PAYOUT_STATUS_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

export function cidPayoutStatusLoaded(cidPayoutStatus) {
  return {
    type: ADMIN_CID_PAYOUT_STATUS_LOADED,
    payload: { cidPayoutStatus },
  };
}

export function cidPayoutStatusClear() {
  return { type: ADMIN_CID_PAYOUT_STATUS_CLEAR };
}

async function fetchCidPayoutSetupStatusApi(token, dispatch) {
  const response = await api.get({
    path: 'payouts/setup-status',
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

export function initiateFetchCidPayoutSetupStatus() {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const result = await fetchCidPayoutSetupStatusApi(adminToken, dispatch);
      dispatch(cidPayoutStatusLoaded(result.data || []));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function clearCidPayoutSetupStatus() {
  return (dispatch) => {
    dispatch(cidPayoutStatusClear());
  };
}
